import {
  HYDRATE_NEXT,
  HYDRATION_START,
  setHydrationStart,
  setHydrationComplete,
} from '../actions/hydration/orchestration';

import {
  hydrationFeatureSelector,
} from '../selectors/hydration/hydrationSelector';

import hydrationLoadOrder from '../actions/hydration/hydrationLoadOrder';

export const hydrationOrchestrationMiddleware = state => next => (action) => {
  if (action.type && action.type.includes(HYDRATE_NEXT)) {
    const {
      feature,
    } = action.meta;
    const {
      timeout,
    } = action.payload;
    // begin hydration process of this feature if it has not started already
    const hydration = hydrationFeatureSelector(action.meta.feature)(state.getState());
    if ((!hydration) || (hydration && !hydration.hydrated)) {
      next(setHydrationStart(feature));
    }

    // dispatch a delayed action that will force orchestration to continue
    // in events of timeout or exceptions
    setTimeout(() => {
      state.dispatch(setHydrationComplete(feature));
    }, timeout);
  } else if (action.type && action.type.includes(HYDRATION_START)) {
    const {
      feature,
    } = action.meta;
    // this is a new event coming in we need to dispatch a delayed action that
    // will force orchestration to continue in events of timeout or exceptions
    setTimeout(() => {
      state.dispatch(setHydrationComplete(feature));
    }, hydrationLoadOrder[feature].timeout);
    next(action);
  } else {
    // not our action allow to pass through
    next(action);
  }
};
